module.exports = __webpack_public_path__ + "static/media/personal-details.cd42daaf.svg";